import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Card, Col, Row, Typography } from 'antd';
import { FileTextOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { SECTION_ROUTES } from './SectionNav';

const { Title, Text, Paragraph } = Typography;

interface FeatureCard {
    title: string;
    description: string;
    detail: string;
    icon: React.ReactNode;
    route: string;
    accentColor: string;
}

const FEATURES: FeatureCard[] = [
    {
        title: 'Form Editor',
        description: 'Create and modify Digital Enrollment forms',
        detail: 'Load form definition files, edit questions, brands, services, rules, layouts, and actions. Preview and upload changes back to the repository.',
        icon: <FileTextOutlined style={{ fontSize: 28 }} />,
        route: SECTION_ROUTES.formEditor,
        accentColor: '#005893',
    },
    {
        title: 'Application Status Editor',
        description: 'Update service statuses via the Outcome Azure Function',
        detail: 'Look up an application by ID, review its enrolled services, and submit outcome updates directly to the Outcome Azure Function.',
        icon: <ThunderboltOutlined style={{ fontSize: 28 }} />,
        route: SECTION_ROUTES.applicationStatusEditor,
        accentColor: '#008540',
    },
];

const LandingPage: React.FC = () => {
    const history = useHistory();

    return (
        <div style={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '48px 24px',
            background: 'var(--bg-primary)',
        }}>
            <div style={{ maxWidth: 760, width: '100%' }}>
                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: 48 }}>
                    <Title level={2} style={{ margin: 0, color: 'var(--text-primary)' }}>
                        LifeScience Implementations Portal
                    </Title>
                    <Text type="secondary" style={{ fontSize: 15, marginTop: 8, display: 'block' }}>
                        Internal tooling for Digital Enrollment form management and application status workflows
                    </Text>
                </div>

                {/* Feature cards */}
                <Row gutter={24}>
                    {FEATURES.map(feature => (
                        <Col span={12} key={feature.route}>
                            <Card
                                hoverable
                                onClick={() => history.push(feature.route)}
                                style={{
                                    height: '100%',
                                    borderTop: `3px solid ${feature.accentColor}`,
                                    cursor: 'pointer',
                                }}
                                styles={{ body: { padding: '24px', display: 'flex', flexDirection: 'column', gap: 12 } }}
                            >
                                <div style={{ color: feature.accentColor }}>
                                    {feature.icon}
                                </div>
                                <div>
                                    <Title level={5} style={{ margin: 0 }}>{feature.title}</Title>
                                    <Text strong style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
                                        {feature.description}
                                    </Text>
                                </div>
                                <Paragraph type="secondary" style={{ margin: 0, fontSize: 13, lineHeight: 1.6 }}>
                                    {feature.detail}
                                </Paragraph>
                                <div style={{ marginTop: 'auto', paddingTop: 8 }}>
                                    <Button
                                        type="primary"
                                        onClick={e => { e.stopPropagation(); history.push(feature.route); }}
                                        style={{ backgroundColor: feature.accentColor, borderColor: feature.accentColor }}
                                    >
                                        Open →
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default LandingPage;
